<template>
  <ListSearchCheckbox
    :label="label"
    :placeholder="placeholder"
    :use-input="useInput"
    @trigger-autosuggest="filterItems($event)"
  >
    <ul :id="id" class="dea-checkbox-search-list__list-element">
      <li v-for="item in checks" :key="item.id" @click="triggerSearch">
        <Checkbox
          :id="`checkbox-list-single-${id}-${item.id}`"
          :data-test="`checkbox-list-single-${id}`"
          :data-id="item.id"
          :name="`checkbox-list-single-${id}-${item.id}`"
          :checked="checkedIds.includes(item.id)"
          >{{ item.name }}</Checkbox
        >
      </li>
    </ul>
  </ListSearchCheckbox>
</template>

<script>
import Checkbox from "./Checkbox";
import ListSearchCheckbox from "./ListSearchCheckbox";

export default {
  name: "SearchCheckbox",
  components: { Checkbox, ListSearchCheckbox },
  props: {
    label: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    id: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    useInput: {
      type: Boolean,
      default: true,
    },
    filter: {
      type: String,
      default: "",
    },
    checkedIds: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      checks: this.items,
    };
  },
  watch: {
    items() {
      this.checks = this.items;
    },
  },
  methods: {
    triggerSearch(e) {
      let base;
      if (e.target.tagName === "INPUT") {
        base = document.getElementById(this.id);
        if (base) {
          const selected = Array.from(base.querySelectorAll("[type=checkbox]:checked"));
          const values = selected.map(item => item.parentElement.attributes["data-id"].value);
          if (this.filter) this.$emit("trigger-search", this.filter, values);
          else this.$emit("trigger-search", this.id, values);
        }
      }
    },
    filterItems(value) {
      this.checks = this.items.filter(x => x.name.toLowerCase().indexOf(value.toLowerCase()) > -1);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils"; //sass-lint:disable-line clean-import-paths

.dea-checkbox-search-list {
  margin-left: $space-small;

  &__list-container {
    margin-right: 0 !important; //sass-lint:disable-line no-important
  }
}
</style>
